/**
 * Simple Propoerty checker
 * @param obj
 * @param properties
 * @returns {boolean}
 */
export const checkIfPropsExists = (obj: any, ...properties: string[]) => {
  if (obj === null) return false
  return properties.every((property) => !!obj[property])
}
